import { render } from "./AmpunHasil.vue?vue&type=template&id=45548bf2"
import script from "./AmpunHasil.vue?vue&type=script&lang=js"
export * from "./AmpunHasil.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__